import { useMemo } from 'react'
import { unavailableParticipantStatuses } from 'app/frontend/types/custom/EventParticipantStatus'
import { useAuth } from 'app/frontend/base/config/context/auth'
import { useTeamEventParticipantsContext } from '../context/TeamEventParticipantsContext'
import { EventActivityLinkedPlanData } from '../hooks/useEventActivityLinkedPlanData'
import EventActivityPlan from './EventActivityPlan'
import EventPrimaryActivitySelect from './EventPrimaryActivitySelect'

type Props = {
  activity: wowaudit.EventActivity
  activities: wowaudit.EventActivity[]
  linkedPlanData?: EventActivityLinkedPlanData
  linkedPlanDataByActivityId?: Map<number, EventActivityLinkedPlanData>
  isLinkedPlanDataLoading: boolean
  allEncounters?: boolean
}

const EventActivitySpecificEncounter = ({
  activity,
  activities,
  linkedPlanData,
  linkedPlanDataByActivityId,
  isLinkedPlanDataLoading,
  allEncounters,
}: Props) => {
  const { accessLevel } = useAuth()
  const { event, allEntries, activityIssuesById } =
    useTeamEventParticipantsContext()
  const selectableParticipantCount = useMemo(
    () =>
      allEntries.filter(
        (entry) =>
          !unavailableParticipantStatuses.includes(entry.participant.status),
      ).length,
    [allEntries],
  )
  const issues = activityIssuesById.get(activity.id)
  const allSelectedForActivity =
    selectableParticipantCount > 0 &&
    issues?.selectedCount === selectableParticipantCount

  return (
    <EventActivityPlan
      activity={activity}
      activities={activities}
      allSelectedForActivity={allSelectedForActivity}
      linkedPlanData={linkedPlanData}
      linkedPlanDataByActivityId={linkedPlanDataByActivityId}
      isLinkedPlanDataLoading={isLinkedPlanDataLoading}
      titleSlot={
        activities.length > 1 ? (
          <EventPrimaryActivitySelect
            event={event}
            activities={activities}
            canEdit={accessLevel === 'admin'}
          />
        ) : undefined
      }
      allEncounters={allEncounters}
    />
  )
}

export default EventActivitySpecificEncounter
